var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('the-navbar'),_c('router-view'),_c('the-footer'),_c('notifications',{attrs:{"position":"bottom right","classes":"my-notification"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }